import PropTypes from "prop-types";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import NoChartData from "../Shared/NoChartData";

const CHART_ASPECT_RATIO = 5.0 / 3.0;

const DoubleBarChart = ({ title, data, bars }) => {
  if (data.length === 0) {
    return <NoChartData />;
  }

  return (
    <div className="bg-white dark:bg-gray-800 px-4 pb-2 pt-4 rounded-lg w-full card-shadow">
      {title && (
        <h3 className="dark:text-white font-semibold text-center text-gray-900 mb-2">
          {title}
        </h3>
      )}
      <ResponsiveContainer
        width="100%"
        aspect={CHART_ASPECT_RATIO}
        className="mb-4"
      >
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          {bars.map((bar) => (
            <Bar key={bar.dataKey} dataKey={bar.dataKey} fill={bar.fill} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

DoubleBarChart.propTypes = {
  data: PropTypes.array.isRequired,
  bars: PropTypes.array.isRequired,
};

export default DoubleBarChart;
